(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

/**
 * social-share.js
 *
 * Script to inject social media buttons into the page.
 *
 * @author    Richard J. Turner <richardt@mediatel.co.uk>
 * @license   All rights reserved.
 */
(function ($) {
    'use strict';

    var oContainer, onClick;

    onClick = function onClick(oEvent) {
        var oTarget = oEvent.currentTarget;

        oEvent.preventDefault();

        window.open(oTarget.href, oTarget.getAttribute('data-social-medium') || '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');

        return false;
    };

    // We should not do anything for "Email" and "Print" links
    oContainer = $('.social-share a').not('.print, .email').not('#print, #send_email');

    if (oContainer.length) {
        oContainer.bind('click', onClick);
    }
})(jQuery);

},{}]},{},[1])

